export default __webpack_public_path__ + "d4bf8c7e76bf122858ef0df862328d40.png";